import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { redirectUrl } from "../env/env";
import { logoutThunk } from "../redux/slices/authSlice";
import store from "../redux/store";

export const INTERVAL_TIME = 3000; // 3 seconds

export const useAuthWatcher = () => {
  const dispatch = useDispatch();
  const [isWatcherActive, setIsWatcherActive] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsWatcherActive(true); // Activate the watcher after 10 seconds
    }, INTERVAL_TIME);

    return () => clearTimeout(timeoutId); // Cleanup timeout if the component unmounts
  }, []);

  useEffect(() => {
    if (!isWatcherActive) return;

    const checkAuthentication = async () => {
      const knowledgeToken = localStorage.getItem("knowledge_token");

      if (!knowledgeToken) {
        try {
          await store.dispatch(logoutThunk(redirectUrl)).unwrap();
        } catch (error) {
          console.error("Authentication check failed:", error);
        }
      }
    };

    checkAuthentication();
    const intervalId = setInterval(checkAuthentication, INTERVAL_TIME);
    return () => clearInterval(intervalId);
  }, [dispatch, isWatcherActive]); // Dependency includes watcher activation
};
